var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "ci-peergroup-list" },
    [
      _vm.peergroups.length > 0
        ? [
            _vm.variant === "carousel"
              ? [
                  _c(
                    "div",
                    { staticClass: "ci-peergroup-list-carousel ci-card" },
                    [
                      _c(
                        "div",
                        { staticClass: "d-sm-none w-100 py-1" },
                        [
                          _vm._l(_vm.peergroups, function (tile) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "peergroup-tile-wrapper my-3 mx-3 mx-sm-auto mx-xl-3 my-sm-5 d-flex flex-column align-items-start justify-content-center align-items-sm-center no-card outline-primary md",
                                },
                                [
                                  _c(
                                    "ci-router-link",
                                    {
                                      staticClass: "peergroup-tile h-100 w-100",
                                      attrs: {
                                        to: {
                                          name: _vm.$routes
                                            .PRODUCTS_RANKING_INDEX,
                                          params: { peergroup: tile.slug },
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "peergroup-tile-content d-flex w-100 h-100 py-sm-2 justify-content-start justify-content-sm-around",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "px-3 py-2 px-sm-2 py-sm-1",
                                            },
                                            [
                                              _c("div", {
                                                staticClass: "mdi mdi-36px",
                                                class: tile.icon,
                                              }),
                                            ]
                                          ),
                                          _c("div", {
                                            staticClass:
                                              "text-center font-weight-normal flex-center",
                                            domProps: {
                                              textContent: _vm._s(
                                                _vm.$t(tile.label_key)
                                              ),
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          }),
                        ],
                        2
                      ),
                      _c(
                        "b-carousel",
                        {
                          staticClass: "px-2 d-none d-sm-flex flex-grow-1",
                          attrs: {
                            id: "peergroup-teaser-list",
                            interval: 4000,
                          },
                        },
                        _vm._l(_vm.pages, function (page, index) {
                          return _c(
                            "b-carousel-slide",
                            { key: index, staticClass: "flex-grow-1" },
                            [
                              _vm._l(page, function (tile) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "peergroup-tile-wrapper my-3 mx-3 mx-sm-auto mx-xl-3 my-sm-5 d-flex flex-column align-items-start justify-content-center align-items-sm-center no-card outline-primary md",
                                    },
                                    [
                                      _c(
                                        "ci-router-link",
                                        {
                                          staticClass:
                                            "peergroup-tile h-100 w-100",
                                          attrs: {
                                            to: {
                                              name: _vm.$routes
                                                .PRODUCTS_RANKING_INDEX,
                                              params: { peergroup: tile.slug },
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "peergroup-tile-content d-flex w-100 h-100 py-sm-2 justify-content-start justify-content-sm-around",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "px-3 py-2 px-sm-2 py-sm-1",
                                                },
                                                [
                                                  _c("div", {
                                                    staticClass: "mdi mdi-36px",
                                                    class: tile.icon,
                                                  }),
                                                ]
                                              ),
                                              _c("div", {
                                                staticClass:
                                                  "text-center font-weight-normal flex-center",
                                                domProps: {
                                                  textContent: _vm._s(
                                                    _vm.$t(tile.label_key)
                                                  ),
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              }),
                            ],
                            2
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ]
              : _vm._e(),
            _vm.variant === "buttons"
              ? [
                  _c(
                    "div",
                    {
                      staticClass:
                        "ci-peergroup-list-buttons d-flex align-items-center justify-content-center",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "ci-peergroup-list-buttons__wrapper d-flex justify-content-md-center flex-md-wrap",
                        },
                        _vm._l(_vm.peergroups, function (peergroup, index) {
                          return _c(
                            "div",
                            {
                              staticClass:
                                "ci-peergroup-list-buttons__item p-2",
                              style: { order: index + 1 },
                            },
                            [
                              _c("ci-button", {
                                attrs: {
                                  variant: "outline-primary",
                                  size: "md",
                                  icon: peergroup.icon,
                                  label: _vm.$t(peergroup.label_key),
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.clickCallback(peergroup)
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                    ]
                  ),
                ]
              : _vm._e(),
          ]
        : [
            _c("div", { staticClass: "ci-card" }, [
              _c("div", { staticClass: "p-4 text-center text-muted" }, [
                _vm._v(_vm._s(_vm.$t("ui.shared.global.no_data_found"))),
              ]),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }